import React from 'react';
import { Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { PRINTERS_PATH } from '../utils/constants';
import SearchTable from './SearchTable'
import DescriptionObject from './DescriptionObject';
import { compareStrings, TrimNan, drawSupply } from '../utils/utils';
import dayjs from 'dayjs';

const layout = {
    bordered : false,
    showSizeChanger : true, 
    pagination : {pageSize: 100, showSizeChanger: false},
    size: "small",
    rowKey : record => record.id,
};

const nested_layout = {
    bordered : false,
    showSizeChanger : false, 
    pagination : { position: ['none', 'none'] },
    size: "small",
    rowKey : record => record.id,
};

const SuppliesTableEx = (props) => {

    const columns = [   
        {
            title: <FormattedMessage id="DeviceMetersTable.name"/>,
            dataIndex: 'prnName',           
            search: true,
            sorter: {
                    compare: (a, b) => compareStrings(a.prnName, b.prnName),
            },
            render: (_, record) => {
                if (record.enabled === 1)
                {
                    const description_columns = [
                        {
                            title :  <FormattedMessage id="SuppliesHistoryTable.model"/>,
                            data : record['model'],
                        },
                        {
                            title :  <FormattedMessage id="SuppliesTable.status"/>,
                            data : record['status'],
                        },
                        {
                            title :  <FormattedMessage id="CustomTooltip.pages_count"/>,
                            data : record['pagesCount'],
                        },
                        {
                            title :  <FormattedMessage id="SuppliesTable.comment"/>,
                            data : record['prnComment'],
                        },
                        {
                            title :  <FormattedMessage id="SuppliesTable.location"/>,
                            data : record['prnLocation'],
                        },
                        {
                            title :  <FormattedMessage id="HardwareTable.serial"/>,
                            data : record['serialNumber'],
                        },
                        {
                            title :  <FormattedMessage id="DeviceMetersTable.ip"/>,
                            data : record['ip'],
                        },
                    ];

                    const supplies_columns = [
                        {         
                            title: <FormattedMessage id="SuppliesChangesTable.description"/>, 
                            dataIndex: 'description',                          
                            width: 250,
                        },    
                        {
                            title: <FormattedMessage id="SuppliesChangesTable.current_level"/>,
                            dataIndex: 'level',                         
                            render: (_, record) => drawSupply(record)                    
                        },
                        {
                            title: <FormattedMessage id="SuppliesTable.last_maintenance"/>,
                            dataIndex: 'changeDate',                         
                            render: (_, record) => dayjs(record.changeDate).format('LL')                    
                        },
                        {
                            title: <FormattedMessage id="SuppliesTable.pages_printed"/>,
                            dataIndex: 'changePagesCount',                         
                        },
                        {
                            title: <FormattedMessage id="SuppliesTable.next_maintenance"/>,
                            dataIndex: 'nextChangeDate',                         
                            render: (_, record) => dayjs(record.nextChangeDate).format('LL')                    
                        },
                        {
                            title: <FormattedMessage id="SuppliesTable.pages_remaining"/>,
                            dataIndex: 'remainPages',                         
                            render: (_, record) => TrimNan(record.remainPages)                    
                        },
                    ];
                
                    const url = PRINTERS_PATH + "/" + record.id;
                    return(
                    <div>
                        <div style={{ background: "Bisque" }}><h3><Link to={url}>{record.prnName}</Link></h3></div>
                        <div className = "device-description-object"><DescriptionObject object = {description_columns}/></div>
                        <div className = "nested-report-table">
                            {record.supplies instanceof Array &&
                                record.supplies.length > 0 &&
                                <SearchTable
                                    layout = {nested_layout}
                                    type = {undefined}
                                    columns={supplies_columns} 
                                    dataSource={record.supplies}                                     
                                />
                            }
                        </div>
                    </div>
                    );        
                }
                else
                {
                    return(<></>);
                }
            }
        },    
    ];   
        
    return (
        <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = {undefined}
                columns={columns} 
                dataSource={props.data} 
            />
        </div>
    );
}

export default SuppliesTableEx;
